<template>
  <v-app id="inspire">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }} ::</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <Sidebar :drawer="$store.state.drawer"></Sidebar>
    <Header :drawer="$store.state.drawer"></Header>

    <v-content>
      <v-container class="main-right">
        <v-card-title>VUNET Exam</v-card-title>

        <!-- {{learner_course}} -->
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="6"
            v-for="item in learner_course"
            :key="item.id"
          >
            <v-card class="card-payess">
              <v-row>
                <v-col cols="12" sm="6" md="6" class="">
                  <div class="card-head-title pt-3  ">Exam Date</div>
                  <div class="card-head121 ">{{ item.exam_date }}</div>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <div class="card-head-title pt-3">Exam Slot</div>
                  <div class="card-head121" >
                      {{ item.start_time }} to {{ item.end_time }}
                    
                  </div>
                  
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-card class=" " max-width="150">
                    <v-img :src="profilephoto" height="130 ml-n3"></v-img>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <div class="std-name">{{ full_name }}</div>
                  <div class="std-username">{{ username }}</div>

                  <div class="card-head-title mt-5">Course Name</div>
                  <!-- <div class="std-name pgm-no">{{item.course_name_code}}</div> -->
                  <div class="std-name pgm-no">{{ item.program }}</div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <div class="card-head12">
                    <v-btn color="#F05A2B" dark @click="startExam"
                      >Start Exam</v-btn
                    >
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <footer :drawer="$store.state.drawer"></footer>
  </v-app>
</template>
<script>
import Sidebar from "../shared/Sidebar";
import Header from "../shared/Header";
import Footer from "../shared/Footer";
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
  data: () => ({
    dialog: false,
    drawer: null,
    profilephoto: null,
    signature_file: null,
    learner_course: "",
    user_type: "",
    full_name: "",
    username: "",
    program: "",
    snackbar_msg: "",
    snackbar: false,
    color: "",
  }),
  components: {
    Sidebar: Sidebar,
    Header: Header,
    Footer: Footer,
  },
  mounted() {
    this.onload();
  },
  methods: {
    startExam() {
      this.$router.push({ name: "stud-start-exam", target: "blank" });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    onload() {
      axios
        .post("/student/checkUserType")
        .then((res) => {
          if (res.data.status == "YES") {
            this.learner_course = res.data.learner_course;
            if (this.learner_course == "") {
              this.showSnackbar("#b71c1c", "Please fill application form!");
            }else{
              for (let index = 0; index < this.learner_course.length; index++) {
                if (this.learner_course[index].start_time > '12') {
                  this.learner_course[index].start_time = this.tConv24(this.learner_course[index].start_time)
                }else{
                  this.learner_course[index].start_time = this.tConv24(this.learner_course[index].start_time)
                }
                if (this.learner_course[index].end_time > '12') {
                  this.learner_course[index].end_time =  this.tConv24(this.learner_course[index].end_time)
                }else{
                  this.learner_course[index].end_time =  this.tConv24(this.learner_course[index].end_time)
                }
              }
            }
            this.user_type = res.data.user_type;
            this.profilephoto = res.data.profilephoto;
            this.signature_file = res.data.signature_file;
            this.full_name = res.data.full_name;
            this.username = res.data.username;
            // this.program = res.data.program;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    tConv24(time24) {
      var ts = time24;
      var H = +ts.substr(0, 2);
      var h = (H % 12) || 12;
      h = (h < 10)?("0"+h):h;  // leading 0 at the left for 1 digit hours
      var ampm = H < 12 ? " AM" : " PM";
      ts = h + ts.substr(2, 3) + ampm;
      return ts;
      }
  },
};
</script>

<style scoped>
.card-head121 {
        text-align: left;
        font: normal normal medium 18px/22px Roboto !important;
        letter-spacing: 0px;
        font-size: 16px;
        color: #212529;
        font-weight: 500;
    }
.pgm-no {
  width: 12em; /* the element needs a fixed width (in px, em, %, etc) */
  overflow: hidden; /* make sure it hides the content that overflows */
  white-space: nowrap; /* don't break the line */
  text-overflow: ellipsis; /* give the beautiful '...' effect */
  cursor: pointer;
}
.pgm-no:hover {
  overflow: visible;
  white-space: normal;
  cursor: pointer;
}
.button {
  margin: 1rem;
}
.table-data {
  margin: 8px;
}
.table-data {
  margin: 8px;
}
v-simple-table {
  width: auto;
  border: 1px solid hsla(190, 99%, 30%, 1);
}
td,
th {
  padding: 6px;
  border: 1px solid hsla(190, 99%, 30%, 1);
  text-align: center;
}
.text {
  color: white;
}
.std-name {
  text-align: left;
  font-size: 16px;
  font: normal normal medium 12px/14px Roboto !important;
  letter-spacing: 0px;
  color: #212529;
  font-weight: bold;
}
.std-username {
  text-align: left;
  font-size: 14px;
  font: normal normal medium 12px/14px Roboto !important;
  letter-spacing: 0px;

  color: #212529;
  font-weight: 400;
}
.card-head12 {
  text-align: left;
  font: normal normal medium 18px/22px Roboto !important;
  letter-spacing: 0px;

  font-size: 18px;
  color: #212529;
  font-weight: 500;
}
.card-head-title {
  text-align: left;
  font-size: 12px;
  font: normal normal medium 12px/14px Roboto !important;
  letter-spacing: 0px;
  color: #212529;
  font-weight: 500;
}
.card-payess {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #c4c4c4;
  padding: 1rem 1rem 1rem 1rem;
}
</style>
